// extracted by mini-css-extract-plugin
export default {"collapse":"settings_collapse__6UY+4","dropdown":"settings_dropdown__81dbi","dropdownIcon":"settings_dropdownIcon__xTpPi","actionIcon":"settings_actionIcon__IlUhX"};